import React from 'react';
import { withSelectEnumHOC } from 'core/components/HOCs/SelectEnumHOC';
import startCase from 'lodash/startCase';

import { ProjectStatuses } from './enums';

interface Props {
  callback(status: string): void;
  value: string;
}

const Select = withSelectEnumHOC(ProjectStatuses, true, startCase);

function StatusSelector({ callback, value }: Props): JSX.Element {
  return (
    <Select
      onChange={(status: string) => callback(status)}
      style={{ width: '100%' }}
      value={value}
    />
  );
}

export { StatusSelector };
